import { render, staticRenderFns } from "./BBreadcrumbItem.vue?vue&type=template&id=7093407e&scoped=true&"
import script from "./BBreadcrumbItem.vue?vue&type=script&lang=js&"
export * from "./BBreadcrumbItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7093407e",
  null
  
)

export default component.exports